export const THIRD_PARTY_KEY = 'third_party_key';

export interface SecretSettingState {
    has_value: boolean;
    last4: string | null;
    updated_at?: string | null;
}

export interface EffectiveSecretSettingState {
    has_value: boolean;
    last4: string | null;
    inherited: boolean | null;
    source_dealer_id: string | null;
    source_dealer_name: string | null;
}

export interface SecretSettingStatus {
    key: string;
    own: SecretSettingState;
    effective: EffectiveSecretSettingState;
}
